module.exports = __webpack_public_path__ + "static/media/doctor.364f39c1.svg";